import axios from "axios";

const getSocialMediaByName = async (name) => {
  let response;
  try {
    response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/configuration/${name}`,
      {headers: {authorization: JSON.parse(localStorage.getItem('Usuario')).token}}
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
const getSocialMedia = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_API}/configuration`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
const putSocialMedia = async (id, redSocial, state, deleted) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_BACKEND_API}/configuration`, {
      ...redSocial,
      _id: id,
      state: state,
      deleted: deleted,
    }, {headers: {authorization: JSON.parse(localStorage.getItem('Usuario')).token}});
    return response;
  } catch (error) {
    console.log(error);
  }
};
const postSocialMedia = async (redSocial) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_API}/configuration`, {
      ...redSocial,
      state: true,
      deleted: false,
    }, {headers: {authorization: JSON.parse(localStorage.getItem('Usuario')).token}});
    return response;
  } catch (error) {
    console.log(error);
  }
};

export {
  getSocialMedia,
  putSocialMedia,
  postSocialMedia,
  getSocialMediaByName,
};
